import { PlusOutlined } from '@ant-design/icons';
import { Col, Row, Table } from "antd";
import Column from "antd/es/table/Column";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { ContentHeader } from "../../components";
import { Links } from "../../helpers/Links";
import { menuHelper } from "../../helpers/account";
import { dateCommon } from '../../helpers/common';
import { layDSDangKyDaoTao } from '../../services/daotao';
import TrangThaiTag from './TrangThaiTag';
import { searchLength } from '../../constants';
;

const DanhSachCaNhan = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [dataTable, setDataTable] = useState<Array<any>>();
    const menu: any = menuHelper.checkMultiPermission([Links.DangKyDaoTao.ChiTiet]);
    const layDuLieu = async () => {
        try {
            setPage(1);
            setIsLoading(true);
            var rs = await layDSDangKyDaoTao();
            setDataTable((rs || []).map((v: any, index: number) => { return { ...v, key: (v.id && v.id !== 0) ? v.id : `row_${index}` } }));
            setIsLoading(false);
        }
        catch (err: any) {
            toast.error(err);
            setIsLoading(false);
        }
    }

    useEffect(() => {
        layDuLieu();
    }, [])

    return (
        <section>
            <ContentHeader title="Đăng ký đào tạo cá nhân" />
            <Row>
                <Col span="24">
                    <div className="card card-primary">
                        <Table
                            dataSource={dataTable}
                            loading={isLoading}
                            locale={{ emptyText: "Không có dữ liệu" }}
                            pagination={{
                                current: page,
                                onChange: (page, pageSize) => {
                                    setPage(page);
                                },
                            }}
                        >
                            <Column
                                title="STT"
                                key="STT" align="center"
                                render={(value, record, index) =>
                                (
                                    <span>
                                        {(page - 1) * searchLength + index + 1}
                                    </span>
                                )
                                }
                            />
                            <Column title="Nhân viên" dataIndex="hoTen" key="hoTen" />
                            <Column title="Tên đợt đăng ký" dataIndex="ten" key="ten" />
                            <Column title="Năm" dataIndex="nam" key="nam" align="center"
                                render={(value, record, index) => {
                                    return (
                                        <span>
                                            {dateCommon.formatDate(record.nam, "yyyy")}
                                        </span>
                                    );
                                }}
                            />
                            <Column
                                title="Thời gian đăng ký"
                                key="ngayBatDau"
                                width={"210px"} align="center"
                                render={(value, record, index) =>
                                (<span>
                                    {dateCommon.formatDate(value?.ngayBatDau)} - {dateCommon.formatDate(value?.ngayKetThuc)}
                                </span>
                                )
                                }
                            />
                            <Column title="Trạng thái" dataIndex="trangThai" key="trangThai" align="center" render={(value, record) => {
                                return <TrangThaiTag value={record.trangThai} ngayKetThuc={record.ngayKetThuc} />
                            }} />
                            <Column title="" align="center" dataIndex="action" key="action" render={(value: any, record: any) => {
                                return <Link className="hrm-btn hrm-btn-sm btn-primary" to={Links.DangKyDaoTao.ChiTietCaNhan + "?&idDangKyDaoTaoNam=" + record.idDangKyDaoTaoNam}>Xem</Link>
                            }} />
                        </Table>
                    </div>
                </Col>
            </Row>
        </section>
    );
};

export default DanhSachCaNhan;